import React, { useEffect } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
// Hook
import useRadarCharts from '../../hooks/useRadarCharts';

function RadarChart() {
  const { radarData } = useRadarCharts(null);

  useEffect(() => {
    // Add chart license and options
    am4core.addLicense('ch-custom-attribution');
    am4core.options.autoDispose = true;

    // Create chart instance
    const chart = am4core.create('chartRadar', am4charts.RadarChart);

    // Set data
    chart.data = radarData;

    // Create axes
    const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'type';
    categoryAxis.tooltip.background.fillOpacity = 0; 
    categoryAxis.tooltip.background.strokeOpacity = 0; 
    categoryAxis.tooltip.label.fillOpacity = 0;  
    categoryAxis.tooltip.disabled = false;  

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.axisFills.template.fill = chart.colors.getIndex(2);
    valueAxis.renderer.axisFills.template.fillOpacity = 0.05;
    valueAxis.cursorTooltipEnabled = false;
    // Create series
    const series = chart.series.push(new am4charts.RadarSeries());
    series.dataFields.valueY = 'score';
    series.dataFields.categoryX = 'type';
    series.name = 'Flota';
    series.strokeWidth = 3;

    // Add tooltip to show value on hover
    series.tooltipText = "{categoryX}: [bold]{valueY}[/]";
    series.tooltip.pointerOrientation = "vertical";

    // Add cursor for hover interaction
    chart.cursor = new am4charts.RadarCursor();
    chart.cursorTooltipEnabled = false;
    // Add legend
    chart.legend = new am4charts.Legend();

    // Enable export
    chart.exporting.menu = new am4core.ExportMenu();

    
  
    // Cleanup on unmount
    return () => {
      chart.dispose();
    };
  }, [radarData]);

  return (
    <div className="row no-gutters charDashboard2">
      <div className="col" id="chartRadar" />
    </div>
  );
}

export default RadarChart;
